import request from '@/utils/request'

// 获取配置
export function getConfig () {
  return request({
    url: `/index/config/getInfo`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js